
export class AzureAuthenticationError extends Error {
    constructor(message: string) {
        super(message);

        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }

}


export class FileUploadError extends Error {
    constructor(message: string) {
        super(message);
    }
}
